import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 権限取得API
 *
 * アクセストークンに含まれる権限に基づいて、learner権限および契約状況を返却する。
 * - hasNoLearner: アクセストークンにlearner権限が存在しない場合にtrue
 * - hasOnlyOtherLearner: アクセストークンにlearner権限は存在するが、22小学の契約に該当するものがない場合にtrue
 */
export namespace ApiTaLi160 {
  // API Name
  export const name: string = 'ApiTaLi160'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/privileges'

    export interface Request {}

    export interface Response {
      /** アクセストークンにlearner権限が存在しない場合にtrue */
      hasNoLearner: boolean
      /** learner権限は存在するが、22小学の契約に該当するものがない場合にtrue */
      hasOnlyOtherLearner: boolean
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    /** GET リクエストを実行する */
    public get<R>(
      _params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        hasNoLearner: false,
        hasOnlyOtherLearner: false,
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
